<template>
    <div class="simple-form flex col-2">
        <div class="content-caption dashed">
            <span>基本信息</span>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>定义编码</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.innerCode || ''}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>资产品牌</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.innerDevcBrandName || ''}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>资产品牌编码</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.innerDevcBrandCode || ''}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>名称</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.name}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>型号</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.model}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>规格</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.fixedSpec}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>单位</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.theUnit}}</span>
            </div>
        </div>
        <div class="form-group top">
            <div class="form-label">
                <label>图片</label>
            </div>
            <div class="form-value">
                <div v-if="imgFile != null" class="file-area clearfix">
                    <span v-if="imgFile.fileBrowseUrl != null && imgFile.fileBrowseUrl != ''">
                        <swb-file-item :fileUuid="imgFile.fileUuid" :fileBrowseUrl="imgFile.fileBrowseUrl" :deletable="false"></swb-file-item>
                    </span>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>资产描述全称</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.title}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>资产分类</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.innerDevcCatName || ''}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>资产分类编码</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.innerDevcCode || ''}}</span>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>管理信息</span>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>使用方式</label>
            </div>
            <div class="form-value ">
                <span>{{devcUseMannerMap[devcDef.useManner]}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>资产管理方式</label>
            </div>
            <div class="form-value ">
                <span>{{assetTypeMap[devcDef.assetType]}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>按金额管理</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.splitible ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>定义完善程度</label>
            </div>
            <div class="form-value ">
                <span :class="devcDef.normalized ? 'font-green' : 'font-red'">{{devcDef.normalized ? '在账资产' : '账外设备'}}</span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.normalized">
            <div class="form-label">
                <label>资产属性</label>
            </div>
            <div class="form-value ">
                <span>{{assetNatureMap[devcDef.assetNature]}}</span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.normalized">
            <div class="form-label">
                <label>财务类别</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.assetKindName || ''}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>维保分组</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.devcGroupFullName || ''}}</span>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>采购信息</span>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>仅用于临采</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.tempOnly ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>用于采购</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.purchFlag ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.purchFlag">
            <div class="form-label">
                <label>必须集中采购</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.centBuyRequired ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.assetType == 0">
            <div class="form-label">
                <label>需要安装</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.setupFlag ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.assetType == 0">
            <div class="form-label">
                <label>需要供应商提供唯一标识码</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.vendorUknoFlag ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>先进先出</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.stockFifo ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>折旧与分摊规则</span>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>规则名称</label>
            </div>
            <div class="form-value ">
                <span v-if="devcDef.deprSpecId != null && devcDef.deprSpecId != -1"><a class="table-cell-link" @click="showDeprSpec(devcDef.deprSpecId)">{{devcDef.deprSpecName}}</a></span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>规则编码</label>
            </div>
            <div class="form-value ">
                <span v-if="devcDef.deprSpecId != null && devcDef.deprSpecId != -1"><a class="table-cell-link" @click="showDeprSpec(devcDef.deprSpecId)">{{devcDef.deprSpecCode}}</a></span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.normalized">
            <div class="form-label">
                <label>使用年限(月)</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.durableLife || ''}}</span>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>附加信息</span>
        </div>
<!--        <div class="form-group">-->
<!--            <div class="form-label">-->
<!--                <label>商品分类</label>-->
<!--            </div>-->
<!--            <div class="form-value">-->
<!--                <span>{{devcDef.catName}}</span>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="form-group">-->
<!--            <div class="form-label">-->
<!--                <label>商品品牌</label>-->
<!--            </div>-->
<!--            <div class="form-value">-->
<!--                <span>{{devcDef.brandName}}</span>-->
<!--            </div>-->
<!--        </div>-->
        <div class="form-group">
            <div class="form-label">
                <label>转移标记</label>
            </div>
            <div class="form-value ">
                <span>{{migratedFlagMap[devcDef.migratedFlag]}}</span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.assetType == 0">
            <div class="form-label">
                <label>含组装商品</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.asmblFlag ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.assetType == 0 && devcDef.asmblFlag">
            <div class="form-label">
                <label>组装件数量</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.asmbAccCount}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>版本</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.version}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>历史版本</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.historic ? '是' : '否'}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>基础定义编码</label>
            </div>
            <div class="form-value ">
                <span>{{devcDef.baseInnerCode}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>状态</label>
            </div>
            <div class="form-value">
                <span class="font-gray1" v-if="devcDef.applyState == 0">未申请</span>
                <span class="font-gold" v-if="devcDef.applyState == 1">已申请</span>
                <span class="font-green" v-if="devcDef.applyState == 2 && devcDef.auditState == 1">审核已通过</span>
                <span class="font-red" v-if="devcDef.applyState == 2 && devcDef.auditState == -1">审核未通过</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>是否需要财务审核</label>
            </div>
            <div class="form-value">
                <span>{{ devcDef.fiscalAuditNeeded ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.fiscalAuditNeeded">
            <div class="form-label">
                <label>财务审核状态</label>
            </div>
            <div class="form-value">
                <span class="font-green" v-if="devcDef.fiscalAuditState == 1">审核已通过</span>
                <span class="font-red" v-if="devcDef.fiscalAuditState == -1">审核未通过</span>
            </div>
        </div>
        <div class="form-group" v-if="devcDef.fiscalAuditNeeded">
            <div class="form-label">
                <label>财务审核人</label>
            </div>
            <div class="form-value">
                <span>{{ devcDef.fiscalAuditorName }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>在库数量</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.inStkQuantity}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>在库可用数量</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.inStkAvQuantity}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>在用数量</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.inUseQuantity}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>总数量</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.quantity}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>已禁用</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.disabled ? '已禁用' : '未禁用'}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>禁用原因</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.disableCause}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>禁用时间</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.disableTime}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>禁用操作人</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.disablerName}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建人</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.creatorName}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建时间</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.createTime}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>描述</label>
            </div>
            <div class="form-value">
                <span>{{devcDef.memo}}</span>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>资料手册</span>
        </div>
        <el-table :data="devcFiles" border style="width: 100%">
            <el-table-column align="left" prop="fileName" label="手册名称"></el-table-column>
            <el-table-column align="left" width="100" prop="innerOnly" label="使用范围">
                <template slot-scope="scope">
                    <span v-if="scope.row.innerOnly">内部使用</span>
                    <span v-else>通用</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="100" label="操作">
                <template slot-scope="scope">
                    <a class="swb-btn-link" @click="viewManual(scope.row)">预览</a>
                    <a class="swb-btn-link" @click="downloadManual(scope.row)">下载</a>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import appConf from '../../app.conf';
    import {openDeprSpecDetailDlg} from './showDlg'

    import devcDefApi from '../../api/devcDef'

    export default {
        name: 'swb-mercht-devc-def-detail',
        desc: '资产定义详情',
        props: ["defId"],
        data: function () {
            return {
                devcDef: {},
                //
                imgFile: null,
                devcFiles: [],
                assetDeprMethodMap: {},
                allotLogicTypeMaps: getEnumMap("allotAcntMethod", "value2text"),
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                migratedFlagMap: getEnumMap('migratedFlag', 'value2text'),
                devcUseMannerMap: getEnumMap('devcUseManner', 'value2text'),
                assetTypeMap: getEnumMap("assetType", "value2text")
            }
        },
        created: function () {
            this.assetDeprMethodMap = getEnumMap("assetDeprMethod", "name2text");
            //
            this.getDevcDefDetail();
        },
        methods: {
            // 查看资产定义详情
            getDevcDefDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.defId;
                //
                let msgBoxDlg = MsgBox.loading();
                devcDefApi.getMerchtDevcDefInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let devcDef = result.data;
                        if (!Utils.isNoB(devcDef) && !Utils.isNoB(devcDef.transWorthRatio)) {
                            devcDef.transWorthRatio = parseFloat(devcDef.transWorthRatio).toFixed(2);
                        }
                        if (!Utils.isNoB(devcDef) && !Utils.isNoB(devcDef.rmnWorthRatio)) {
                            devcDef.rmnWorthRatio = parseFloat(devcDef.rmnWorthRatio).toFixed(2);
                        }
                        self.devcDef = Utils.merge({}, devcDef);
                        self.devcFiles = Utils.merge([], devcDef.merchtDevcManuals);
                        //
                        let imgFile = {
                            fileBrowseUrl: devcDef.imageUrl
                        };
                        self.imgFile = Utils.merge({}, imgFile);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 资料手册预览
            viewManual: function (row) {
                let fileUuid = row.fileUuid;
                if (Utils.isNoB(fileUuid)) {
                    MsgBox.warning("未找到要下载的文章！");
                    return;
                }
                let fileName = row.fileName;
                let viewUrl = appConf.makeViewableDocUrl(fileName, fileUuid);
                if (viewUrl == null) {
                    MsgBox.warning("此文件不支持在线查看！");
                }
                else {
                    Utils.setPageUrl(viewUrl, '_blank');
                }
            },
            // 资料手册下载
            downloadManual: function (row) {
                let fileUuid = row.fileUuid;
                if (Utils.isNoB(fileUuid)) {
                    MsgBox.warning("未找到要下载的文章！");
                    return;
                }
                Utils.downloadFile(getAppUrl("/file/download?uuid=" + row.fileUuid));
            },
            showDeprSpec(deprSpecId){
                openDeprSpecDetailDlg(deprSpecId);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcDefDetail.vue